export const English = [
    {
        Key: "REGISTER", message: "Registeration Completed Successfully,Kindly Login Into Your Account",
    },
    {
        Key: "REGERROR", message: "Error Occurred While User Registeration"
    },
    {
        Key: "MAILERROR", message: "Enter A Valid User Mail"
    },
    {
        Key: "ALREADYEXISTS", message: "User Already Exists"
    },
    {
        Key: "LOGIN", message: "LoggedIn Successfully"
    },
    {
        Key: "INVALID", message: "Invalid Credentials"
    },
    {
        Key: "REQUIRED", message: "Kindly Fill All Required Fields"
    },
    {
        Key: "PASSWORDSAME", message: "Both Password And Confirm Password Must Be Same"
    },
    {
        Key: "LINKEXPIRED", message: "Link Has Been Expired"
    },
    {
        Key: "NOTFOUND", message: "User Not Found"
    },
    {
        Key: "VERIFYERROR", message: "Error Occured While Verify Link Has Been Expired"
    },
    {
        Key: "VERIFYSUCC", message: "Account Confirmation Completed Successfully, Kindly Proceed To Login"
    },
    {
        Key: "VERIFYSUCCESS", message: "Account Activation Link Has Been Expired, Kindly Check Your Mail To Activate Your Account"
    },
    {
        Key: "ALREADYACTIVATED", message: "Account Already Activated"
    },
    {
        Key: "PENDINGACTI", message: "Your Account Verification Is Still Pending ,Kindly Check Your Mail To Activate Your Account"
    },
    {
        Key: "DEACTIVATED", message: "Your Account Is De-Activated, Kindly Contact Help Center"
    },
    {
        Key: "LOCKED", message: "Your Account Is Locked, Kindly Contact Help Center"
    },
    {
        Key: "TFALOGIN", message: "Kindly Verify TFA To Login"
    },
    {
        Key: "USERDETAILSERROR", message: "Error Occurred While Fetching User Details"
    },
    {
        Key: "PASSOWORDSERROR", message: "Error Occurred While Change Your Password"
    },
    {
        Key: "PASSOWORDSUCCESS", message: "Your Password Has Been Changed Successfully"
    },
    {
        Key: "PASSOWORDERROR1", message: "Unable To Change Your Password"
    },
    {
        Key: "PASSWORDERROR2", message: "Your Old Password Is Wrong"
    },
    {
        Key: "FORGOTERROR", message: "Kindly Activate Your Account For Forgot Password,Kindly Activate Your Account Then Proceed"
    },
    {
        Key: "FORGOTERROR1", message: "Unable To Reset Your Password"
    },
    {
        Key: "RESETFORGOTERR", message: "Error Occurred While Reset Your Password"
    },
    {
        Key: "VERIFYSUC", message: "Verified Successfully"
    },
    {
        Key: "INCORRECT", message: "Incorrect Password"
    },
    {
        Key: "TFACHECK", message: "Kindly Enter Correct Code To Disable Tfa"
    },
    {
        Key: "TFADISABLE", message: "TFA Disabled Successfully"
    },
    {
        Key: "TFAERR", message: "Unable To Disable The Tfa"
    },
    {
        Key: "LOGOUTSUC", message: "Logout From Your Account Successfully"
    },
    {
        Key: "LOGOUTERR", message: "Unable To Logout From Your Account"
    },
    {
        Key: "ERRLINKMAIL", message: "Error Occurred While User Link Mail"
    },
    {
        Key: "LINKMAIL", message: "Verification Mail Sent Successfully"
    },
    {
        Key: "VERIFYLINKMAIL", message: "Error Occurred While Verify User Link Mail"
    },
    {
        Key: "GOOGLEERR", message: "Error Occurred While Google Login"
    },
    {
        Key: "FBERR", message: "Error Occurred While Facebook Login"
    },
    {
        Key: "APPLEERR", message: "Error Occurred While Apple Login"
    },
    {
        Key: "IMGERR", message: "Kindly Select JPG,JPEG,PNG Format Only"
    },
    {
        Key: "IMGERROR", message: "Error Occurred While Update Image"
    },
    {
        Key: "BANKERR", message: "Error Occurred While Update Bank Details"
    },
    {
        Key: "BANKALREADY", message: "Bank/UPI Already Exists"
    },
    {
        Key: "UPISUCC", message: "UPI Added Successfully"
    },
    {
        Key: "ERRBANKDATA", message: "Error Occured While User Add Bank Details"
    },
    {
        Key: "MAXLIMITERR", message: "Maximium Limit Reached, Unable To Add Bank Details"
    },
    {
        Key: "BANKADDERR", message: "No Changes Occurs While Adding Bank"
    },
    {
        Key: "BANKSUCC", message: "Bank Added Successfully"
    },
    {
        Key: "BANKUPDATEERR", message: "No Changes Occurs While Updating Bank"
    },
    {
        Key: "ERRACTIVEBANK", message: "Error Occurred While Change Status For User Active Banks"
    },
    {
        Key: "ACTBANKSATATUS", message: "Bank Status Activated Successfully"
    },
    {
        Key: "DEAACTBANKSTATUS", message: "Bank Status Deactivated Successfully"
    },

    {
        Key: "ALREADYDEACTIVATED", message: "Bank Status Already Deactivated"
    },
    {
        Key: "UNABLEEDIT", message: "Unable To Edit This Record Already Approved"
    },
    {
        Key: "UPDATEBANK", message: "Bank Record Updated Successfully"
    },
    {
        Key: "NOCHANGE", message: "No Changes Occurs While Updating Bank/UPI Details"
    },
    {
        Key: "ERRUPDATE", message: "Error Occurred While Updating Bank/UPI Details"
    },
    {
        Key: "BANKSTATUSUPDATE", message: "Error Occurred While Change Status For Update Bank Details"
    },
    {
        Key: "NORECORDS", message: "No Records Found"
    },
    {
        Key: "DELETEBANKERR", message: "Error Occurred While Delete Bank Details"
    },
    {
        Key: "ADMINREMOVEBANK", message: "Error Occurred While Removing Bank Details By Admin"
    },
    {
        Key: "AMINREMOVEBANKSUCC", message: "Bank Record Removed By Admin Successfully"
    },
    {
        Key: "CONSTRAINT", message: "Unable To Remove Bank Details, Atleast One Bank Must Be Active"
    },
    {
        Key: "GETBANKDATA", message: "Error Occured While Fetching Active Banks For Users"
    },
    {
        Key: "FETCHERRBANK", message: "Error Occurred While Fetch Users Bank Detail"
    },
    {
        Key: "LOGINERRACT", message: "Error Occurred While Fetching User Activity"
    },
    {
        Key: "CONTACTUSERR", message: "Error Occurred While Send Query To Admin"
    },
    {
        Key: "QUERYREQ", message: "Query Submitted To Admin Successfully"
    },
    {
        Key: "REMOVEDEVICEERR", message: "Error Occurred While Removing Device"
    },
    {
        Key: "REMOVEDEVICE", message: "Device Removed Successfully"
    },
    {
        Key: "NOCHANGESUPI", message: "No Changes Occurs While adding UPI"
    },
    {
        Key: "UNABLETOEDIT", message: "Unable To Edit Bank Status, Atleast One Bank Must Be Active"
    },
    {
        Key: "CHECKADMINAPPROVAL", message: "Unable To Edit Bank Status Before Admin Approval"
    },
    {
        Key: "PASSWORDCHECK", message: "Old Password and New Password Not be Same"
    },
    {
        Key: "FORGOTSUCC", message: "Forgot Password Request Sent Successfully. Kindly Check Your Email to Further Process"
    },
    {
        Key: "NOTVERIFIED", message: "Not Verified"
    },
    {
        Key: "RESETPASSWORD", message: "Password Reseted Successfully, Kindly Login With New Password"
    },
    {
        Key: "TFACODEERR", message: "Kindly Enter A Valid 2FA Code To Enable 2FA"
    },
    {
        Key: "TFASUCCESS", message: "2FA Enabled Successfully"
    },
    {
        Key: "ALREADYTFA", message: "2FA Already Enabled"
    },
    {
        Key: "UNABLETFA", message: "Unable To Enable 2FA"
    },
    {
        Key: "LOGINWITHTFA", message: "2FA Is Successfully Verified.. Logged In Successfully"
    },
    {
        Key: "ERRORTFAVERIFY", message: "Error Occurred While Verify Login TFA"
    },
    {
        Key: "MAILVERIFYSUCC", message: "Your Email Has Been Verified Successfully"
    },
    {
        Key: "UPDATEPROFILEERR", message: "Error Occurred While Update Profile"
    },
    {
        Key: "NOCHANGEPROFILE", message: "No Changes Occurs While updating profile"
    },
    {
        Key: "PROFILESUCC", message: "Profile Updated Successfully"
    },
    {
        Key: "ERRORKYC", message: "Error Occurred While Update Kyc Details"
    },
    {
        Key: "KYCUPDATEERR", message: "Unable To Update Your Kyc Details"
    },
    {
        Key: "KYCREUPLOAD", message: "KYC Doucments ReUpload Successfully"
    },
    {
        Key: "REUPLOADKYCCHANGE", message: "No Changes Occurs While ReUpload KYC Doucments"
    },
    {
        Key: "KYCSUCC", message: "Your KYC Documents Submitted Successfully"
    },
    {
        Key: "ALREADYKYC", message: "Your KYC Document Already Approved"
    },
    {
        Key: "HISTORYDEPOSIT", message: "Error Occured While Fetching Users Deposit History"
    },
    {
        Key: "HISTORYWITHDRAW", message: "Error Occured While Fetching Users Withdraw History"
    },
    {
        Key: "SINGLEHISTORY", message: "Error Occured While Fetching User Deposit Or Withdraw History"
    },
    {
        Key: "HOLDBALANCEERR", message: "Error Occured While Fetching User Balance Along With Hold Balanc"
    },
    {
        Key: "TRANSHISERR", message: "Error Occured While Fetching User Transaction History"
    },
    {
        Key: "KYCCHECKERR", message: "Complete KYC to Proceed Deposit process"
    },
    {
        Key: "AMOUNTZERO", message: "Amount Must Be Greater Than 0"
    },
    {
        Key: "DEPOSITERR", message: "Error Occured While User Deposit Request"
    },
    {
        Key: "DEPOSITSUCBYBANK", message: "Deposit Request By Bank Sent To Admin Successfully"
    },
    {
        Key: "DEPOSITSUCBYUPI", message: "Deposit Request By UPI Sent To Admin Successfully"
    },
    {
        Key: "MINDEPOSIT", message: "You Can Make Minimum Deposit of "
    },
    {
        Key: "MAXDEPOSIT", message: "You Can Make Maximum Deposit of  "
    },
    {
        Key: "DEPOSITADMINAPPROVE", message: "Deposit Only Allowed After Admin Approval, Kindly Try With Another Bank"
    },
    {
        Key: "DEPOSITADMINREJECT", message: "Deposit Request Account Rejected By Admin, Kindly Try With Another Bank"
    },
    {
        Key: "DEPOSITBANKVAL", message: "Kindly Activate Bank Details To Proceed Deposit"
    },
    {
        Key: "WITHDRAW2FACHECK", message: "Enable 2FA To Proceed Withdraw Process"
    },
    {
        Key: "WITHDRAWKYCCHECK", message: "Complete KYC To Proceed Withdraw Process"
    },
    {
        Key: "WITHDRAWKYCTFA", message: "Complete KYC And Enable 2FA For Proceed Withdraw Process"
    },
    {
        Key: "MINWITHDRAW", message: "You Can Make Minimum Withdraw of "
    },
    {
        Key: "MAXWITHDRAW", message: "You Can Make Maximum Withdraw of "
    },
    {
        Key: "WITHDRAWFEEGREATER", message: "Kindly Enter Amount Greater Than Withdraw Fee"
    },
    {
        Key: "INSUFFICIENTFUNDS", message: "Insufficient Funds"
    },
    {
        Key: "WITHDRAWERR", message: "Error Occurred While Send Withdraw Request"
    },
    {
        Key: "WITHDRAWSUCC", message: "Withdraw Confirmation Mail Sent To Your Mail Successfully,Kindly Check Your Mail To Approve"
    },
    {
        Key: "FAILWITHDRAW", message: "Withdraw Request Failed"
    },
    {
        Key: "WITHDRAWLINK", message: "Withdraw Verification Link Expired, Kindly Check Your Mail To Proceed Withdraw Request"
    },
    {
        Key: "WITHDRAWANOTHER", message: "Kindly Initiate Another Withdraw Request To Proceed Withdraw Request"
    },
    {
        Key: "USERCONFIRMERROR", message: "Error Occurred While User Confirm Approved Withdraw Request"
    },
    {
        Key: "USERCONFIRMWITHDRAW", message: "Withdraw Request Successfully Sent To Admin"
    },
    {
        Key: "WITHDRAWUSERREJECT", message: "Error Occurred While User Confirm Cancel Withdraw Request"
    },
    {
        Key: "WITHDRAWCONFIRMREJECT", message: "Error Occurred While User Confirm/Cancel Withdraw Request"
    },
    {
        Key: "WITHDRAWACANCEL", message: "Withdraw Request Cancelled By User"
    },
    {
        Key: "WITHDRAWCANCELLEDUSER", message: "Withdraw Request Already Cancelled By User"
    },
    {
        Key: "WITHDRAWINPROGRESS", message: "Withdraw Request Already Inprogress"
    },
    {
        Key: "ADMINAPPROVEORREJECT", message: "Error Occurred While Approve Or Reject User Deposit"
    },
    {
        Key: "ADMINAPPROVEDEPOSIT", message: "Error Occurred While Approve User Deposit Request"
    },
    {
        Key: "ADMINAPPORVEDEPOSIT", message: "Deposit Request Approved By Admin Successfully"
    },
    {
        Key: "ADMINDEPOSITCOMPLETED", message: "Deposit Request Already Completed"
    },
    {
        Key: "DEPOSITERRUSER", message: "Error Occurred While Reject User Deposit Request"
    },
    {
        Key: "DEPOSITREJ", message: "Deposit Request Rejected By Admin"
    },
    {
        Key: "DEPOSITREJALREADY", message: "Deposit Request Already Rejected"
    },
    {
        Key: "ADMINCANCELWITHDRAW", message: "Withdraw Request Cancelled By Admin"
    },
    {
        Key: "WITHDRAWCOMPLETED", message: "Withdraw Request Already Completed"
    },
    {
        Key: "APPROVEREJECTWITHDRAW", message: "Error Occurred While Approve Or Reject User Withdraw"
    },
    {
        Key: "USERCANCELWITHDRAW", message: "Error Occurred While Cancelled User Withdraw Request"
    },
    {
        Key: "HOLDAMOUNT0", message: "User Hold Amount Is 0.. Withdraw Request Cancelled By Admin Successfully"
    },
    {
        Key: "WITHDRAWADMIN", message: "Withdraw Request Approved By Admin Successfully"
    },
    {
        Key: "WITHDRAWAPPROVERR", message: "Error Occurred While Approved User Withdraw Request"
    },
    {
        Key: "USERCANTPROCEED", message: "User Can't Confirm Or Cancel Withdraw Request"
    },
    {
        Key: "DEPOSITALREADY", message: "Deposit Request Already Completed"
    },
    {
        Key: "DEPOSITCANCELLED", message: "Deposit Request Already Cancelled"
    },
    {
        Key: "SITERR", message: "Error Occurred While Fetching Site Settings"
    },
    {
        Key: "CMSERR", message: "Error Occurred While Fetching CMS"
    },
    {
        Key: "USERSTATERR", message: "Error Occurred While Fetching Single User Statistics By Game"
    },
    {
        Key: "USERALLGAMESTAT", message: "Error Occurred While Fetching Overall Single User Statistics"
    },
    {
        Key: "GAMEERR", message: "Error Occurred While Fetching Single User Game History"
    },
    {
        Key: "COMMONGAMEERR", message: "Error Occurred While Fetching Game History"
    },
    {
        Key: "CRASHGAMEPHASE", message: "Wait For Game Phase.."
    },
    {
        Key: "NOACTIVEUSER", message: "Not A Active User"
    },
    {
        Key: "CRASHRESULTUPD", message: "Crash Results Already Completed"
    },
    {
        Key: "WONGAME", message: "You`re Won"
    },
    {
        Key: "LOSSGAME", message: "OOPS..!! You`re lost"
    },
    {
        Key: "CRASHERR", message: "Error Occurred While Update Crash Results"
    },
    {
        Key: "BETERR", message: "Error Occurred While Fetching Current Bet"
    },
    {
        Key: "ISNAN", message: "Enter A Valid Number.."
    },
    {
        Key: "INSUFFICIENT", message: "Insufficient Balance To Bet"
    },
    {
        Key: "BETHASE", message: "Wait For Betting Phase.."
    },
    {
        Key: "BET", message: "Bet Placed Successfully"
    },
    {
        Key: "MINESERR", message: "Error Occurred While Update Mines results"
    },
    {
        Key: "MINESUPDATE", message: "Mine Results Already Completed"
    },
    {
        Key: "HITIDERR", message: "Hit Id Must Be Lesser Than Hit Count"
    },
    {
        Key: "BETCREATEERR", message: "Error Occurred While Creating Bet"
    },
    {
        Key: "CURRERR", message: "Error Occurred While Fetching Single Currency"
    },
    {
        Key: "CREATE_PAYMENT", message: "Payment created successfully"
    },
    {
        Key: "PAYMENT_ERR", message: "Create payment error"
    },
    {
        Key: 'WITHDRAWREQ', message: "Maximum Withdraw Request Reached"
    },
    {
        Key: "INVALIDCOUNT", message: "Invalid Diamond Count"
    },
    {
        Key: "BLOCKEDUSER", message: "Unable To Login"
    },
    {
        Key: "MAILACTIVATED", message: "Account Confirmation Completed Successfully, Kindly Proceed To Login",
    },
    {
        Key: "ALREADYACTIVATED", message: "Account Activated Already"
    },
    {
        Key: "MAILRESENT", message: "Kindly Check Your Mail to Account Activate"
    },
    {
        Key: "ALREADYACTIVATED", message: "Account Already Activated"
    },
    {
        Key: "EMAILERR", message: "Error Occurred While Sending Mail"

    },
    {
        Key: "MAILRESENT", message: "Kindly Check Your Mail to Account Activate"

    },
    {
        Key: "NOCHANGECPF", message: "No Changes Occurs While updating CPF",
    },
    {
        Key: "CPFSUCC", message: "CPF Updated Successfully"
    },
    {
        Key: "CPFALREADY", message: "CPF Already Updated",
    },

]
